import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function VerifyToken() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [status, setStatus] = useState('verifying');
    const [error, setError] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            setStatus('error');
            setError('No token provided');
            return;
        }

        verifyToken(token);
    }, [searchParams]);

    const verifyToken = async (token) => {
        try {
            const response = await fetch(
                `/api/auth/verify?token=${token}`
            );

            const data = await response.json();

            if (response.ok) {
                login(data.token, data.user);
                setStatus('success');
                setTimeout(() => navigate('/'), 1000);
            } else {
                setStatus('error');
                setError(data.error || 'Verification failed');
            }
        } catch (error) {
            setStatus('error');
            setError('Failed to verify token');
        }
    };

    return (
        <div className="verify-container">
            {status === 'verifying' && (
                <div className="auth-card">
                    <h2>Verifying your link...</h2>
                    <p>Please wait</p>
                </div>
            )}

            {status === 'success' && (
                <div className="auth-card success">
                    <h2>Success!</h2>
                    <p>Redirecting to dashboard...</p>
                </div>
            )}

            {status === 'error' && (
                <div className="auth-card error">
                    <h2>Verification Failed</h2>
                    <p>{error}</p>
                    <button onClick={() => navigate('/login')}>
                        Try Again
                    </button>
                </div>
            )}
        </div>
    );
}
